import r from "./Snake.vue2.js";
import { openBlock as e, createElementBlock as n, normalizeStyle as i } from "vue";
/* empty css           */
import p from "../../../_virtual/_plugin-vue_export-helper.js";
function t(o, s, l, a, m, c) {
  return e(), n("div", {
    class: "ap-spinner-snake",
    style: i({
      "border-top-color": o.spinnerColor,
      "border-left-color": o.spinnerColor,
      "border-bottom-color": o.spinnerColor,
      height: o.spinnerSize,
      width: o.spinnerSize
    })
  }, null, 4);
}
const h = /* @__PURE__ */ p(r, [["render", t]]);
export {
  h as default
};
